<h1 mat-dialog-title>{{ 'DELETE-PROFILE-DIALOG.DELETE-TITLE' | translate }}</h1>
<div mat-dialog-content>
    <p>{{ 'DELETE-PROFILE-DIALOG.CONFIRM-MESSAGE' | translate }}</p>
    <p class="caution-text">{{ 'DELETE-PROFILE-DIALOG.CAUTION-MESSAGE' | translate }}</p>
</div>
<div mat-dialog-actions>
    <button class="profile-btn yes-profile-btn" mat-flat-button (click)="confirmDelete()">{{ 'DELETE-PROFILE-DIALOG.YES' | translate }}</button>
    <button  class=" profile-btn no-profile-btn" mat-flat-button (click)="cancel()">{{ 'DELETE-PROFILE-DIALOG.NO' | translate }}</button>
</div>
